enum MessageBarTypes {
    error = "error",
    info = "info",
    /** Действие не выполнено, но это не ошибка: например, уход во время отправки */
    warning = "warning",
    success = "success"
}

export { MessageBarTypes };